import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'admin/empresas',
		component: Base,
		children: [
			{
				path: '',
				name: 'EmpresasList',
				component: List,
				meta: {
					path: '/admin/empresas',
					pai: 'Admin',
					title: 'siS - Empresas',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Empresas',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'EmpresasNovo',
				component: Form,
				meta: {
					path: '/admin/empresas',
					pai: 'Admin',
					title: 'siS - Empresas - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Empresas',
						class: '',
						active: false,
						url: '/admin/empresas'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'EmpresasEditar',
				component: Form,
				meta: {
					path: '/admin/empresas',
					pai: 'Admin',
					title: 'siS - Empresas - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Empresas',
						class: '',
						active: false,
						url: '/admin/empresas'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]